import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CouponService } from 'src/app/services/coupon.service';

@Component({
  selector: 'app-disable-coupon',
  templateUrl: './disable-coupon.component.html',
  styleUrls: ['./disable-coupon.component.css']
})
export class DisableCouponComponent implements OnInit {
  api_success: string;
  api_error: any;
  code: any;
  providerAlerts: any;

  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private couponService: CouponService ) { }

  ngOnInit() {
    this.code = this.data;
  }
  onDisableConfirm() {
    const alertmsg = { 'message': this.providerAlerts };
    this.couponService.disableCoupon(this.data, alertmsg)
    .subscribe(
      res => {
        this.api_success = 'Coupon disabled Successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
          }, 2000);
        },
        (error) => {
            this.api_error = error.error;
          }
    );

  }
}
